// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"8288dc29","366":"52bb7947","718":"26b41022","837":"3353ac05"}[chunkId] + ".js";
};